module.exports = __webpack_public_path__ + "static/badge-png-b97356268dec0a5cfddba0b799bf23cd.png";